import React from "react";
import ComplaintAddModal from "./ComplaintAddModal";

function AddComplaint({ open, onClose }) {
  return <ComplaintAddModal open={open} onClose={onClose} />;
}

export default AddComplaint;
